import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import { styled, useTheme } from '@mui/material';
import { Typography } from '../Typography/Typography';
import { useTranslation } from 'react-i18next';

export interface SpinnerProps {
    enabled?: boolean;
    message?: string | null;
    size?: 'small' | 'large';
    messageColor?: string;
    position?: 'fixed' | 'absolute' | 'relative';
}

export const Spinner = ({ enabled, message, size = 'large', messageColor, position = 'fixed' }: SpinnerProps) => {
    const { t } = useTranslation();
    const theme = useTheme();
    if (!enabled) {
        return null;
    }

    const sizePixels = size === 'small' ? 40 : 64;
    const spinnerMessage = message ?? t('SPINNER_LOADING_MESSAGE');

    return (
        <StyledSpinner
            sx={{
                zIndex: (theme) => theme.zIndex.drawer + 1,
                position: position
            }}
        >
            <Stack spacing={2} direction="row">
                <Box sx={{ position: 'relative' }}>
                    <CircularProgress
                        variant="determinate"
                        sx={{
                            color: theme.palette.neutral[200]
                        }}
                        size={sizePixels}
                        thickness={4}
                        value={100}
                    />
                    <CircularProgress
                        size={sizePixels}
                        thickness={4}
                        sx={{
                            position: 'absolute',
                            left: 0,
                            color: theme.palette.primary[500]
                        }}
                    />
                </Box>
            </Stack>
            <StyledSpinnerMessage variant="body.large" sx={messageColor ? { color: messageColor } : {}}>
                {spinnerMessage}
            </StyledSpinnerMessage>
        </StyledSpinner>
    );
};

const StyledSpinner = styled('div')(() => ({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    background: 'rgba(255,255,255,0.4)',
    width: '100%',
    height: '100%',
    top: 0,
    left: 0
}));

const StyledSpinnerMessage = styled(Typography)(() => ({
    marginTop: '1rem'
}));
